import React, { forwardRef } from 'react';
import { styleIcon } from '../style_icon.js';
export const ExclamationTriangleIcon = forwardRef(({ title = 'Exclamation Triangle Icon', ...rest }, ref) => {
    const props = styleIcon(rest);
    return (React.createElement("svg", { ...props, ref: ref, viewBox: "0 0 16 13" },
        !props['aria-hidden'] && React.createElement("title", null, title),
        React.createElement("path", { d: "M15.91 12.16 8.41.24a.5.5 0 0 0-.83 0L.08 12.16c-.22.36.02.84.42.84h15c.4 0 .64-.48.41-.84M7.52 4.17h.96c.25 0 .45.23.43.5L8.7 7.4a.45.45 0 0 1-.44.42h-.5a.45.45 0 0 1-.44-.42L7.1 4.66a.45.45 0 0 1 .43-.5M8 11a1 1 0 1 1 0-2 1 1 0 0 1 0 2" })));
});
//# sourceMappingURL=exclamation_triangle_icon.js.map